module.exports = __webpack_public_path__ + "static/media/icon_similarity2.d8be226a.png";